import { render, staticRenderFns } from "./GBRightPaneClassSelect.vue?vue&type=template&id=79aa63a2&"
import script from "./GBRightPaneClassSelect.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneClassSelect.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneClassSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTextField})
